import React from 'react';

import { translate } from 'services/i18nService';

import toyIcon from '../../../images/icons/toys-mkt-graphic.png';
import giftsIcon from '../../../images/icons/gifts-mkt-graphic.png';
import vidIcon from '../../../images/icons/vid-mkt-graphic.png';
import pvtIcon from '../../../images/icons/pvt-graphic.png';
import diceIcon from '../../../images/icons/dice-mkt-graphic.png';

import styles from './TokenAwarenessDesktop.css';


function TokenAwarenes() {
  return (
    <div>
      <div className={styles.title}>{translate('strings.tokenAawareness.overlay.title')}</div>
      <div className={styles.row}>
        <img alt="private" src={pvtIcon} />
        {translate('strings.tokenAawareness.overlay.message.privateShow')}
      </div>
      <div className={styles.row}>
        <img alt="toy" src={toyIcon} />
        {translate('strings.tokenAawareness.overlay.message.toys')}
      </div>
      <div className={styles.row}>
        <img alt="gifts" src={giftsIcon} />
        {translate('strings.tokenAawareness.overlay.message.gifts')}
      </div>
      <div className={styles.row}>
        <img alt="dice" src={diceIcon} />
        {translate('strings.tokenAawareness.overlay.message.rollDice')}
      </div>
      <div className={styles.row}>
        <img alt="video" src={vidIcon} />
        {translate('strings.tokenAawareness.overlay.message.videos')}
      </div>
    </div>
  );
}

export default TokenAwarenes;
